module.exports = "var output = \"The answer: \"\n\nprint(src: 42, dest: output)"